import moment from 'moment';

export const years = (y: number) => moment.duration(y, 'years');
export const months = (m: number) => moment.duration(m, 'months');
export const weeks = (w: number) => moment.duration(w, 'weeks');
export const days = (d: number) => moment.duration(d, 'days');
export const hours = (h: number) => moment.duration(h, 'hours');
export const minutes = (m: number) => moment.duration(m, 'minutes');
export const seconds = (s: number) => moment.duration(s, 'seconds');
export const milliseconds = (ms: number) => moment.duration(ms, 'milliseconds');
